import React from 'react';
import { getFeatureToggle, ToggleNames } from 'helpers/featureToggle';
import { ActionsElementContainer } from 'modules/ProductManagement/style';
import { fetchCheckoutRedirectUrl } from 'modules/ProductManagement/reducers/checkout';
import { TProduct, ProductManagementContext } from 'modules/ProductManagement/reducers/type';
import { Button } from '@myob/myob-widgets';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { ActionsWrapper } from './styles';
import { RootState } from 'stores';
import { ENotificationStatus, EActionType, EActionStatus, EButtonNames } from 'modules/ProductManagement/type';
import { trackClickEventInProductManagement } from 'modules/ProductManagement/helper';
import { getProductManagementContext } from 'modules/ProductManagement/reducers/accessors';
import { useHistory } from 'react-router-dom';
import { ERoutePath } from 'router';
import { getFirstElementInProductList } from '../../reducers/accessors';

const Actions: React.FC = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { actions, notifications } = useSelector<RootState, TProduct>(getFirstElementInProductList);
    const isLoading = useSelector<RootState, boolean>(state => state.productManagement.checkout.isLoading);
    const productManagementContext = useSelector<RootState, ProductManagementContext>(
        getProductManagementContext,
        shallowEqual,
    );

    const actionNotification = notifications?.find(notification => notification.type === ENotificationStatus.ACTION);

    const subscribeAction = actions?.find(action => action.id === EActionType.SUBSCRIBE);
    const handleSubscribeClick = () => {
        trackClickEventInProductManagement(productManagementContext, EButtonNames.Subscribe);
        dispatch(fetchCheckoutRedirectUrl(EActionType.SUBSCRIBE));
    };

    const changePlanAction = actions?.find(action => action.id === EActionType.CHANGE_PLAN);
    const handleChangePlanClick = () => {
        trackClickEventInProductManagement(productManagementContext, EButtonNames.ChangePlan);
        dispatch(fetchCheckoutRedirectUrl(EActionType.CHANGE_PLAN));
    };

    const editPaymentDetailsAction = actions?.find(action => action.id === EActionType.EDIT_PAYMENT_DETAILS);
    const handleEditPaymentDetailsClick = () => {
        trackClickEventInProductManagement(productManagementContext, EButtonNames.EditPaymentDetail);
        history.push(ERoutePath.EditPaymentDetails);
    };
    return (
        <>
            {getFeatureToggle(ToggleNames.FEATURE_CHECKOUT_ACTIONS) && (
                <ActionsElementContainer>
                    <h6>Actions</h6>
                    <ActionsWrapper>
                        {subscribeAction && (
                            <Button
                                type="primary"
                                onClick={handleSubscribeClick}
                                disabled={subscribeAction.status === EActionStatus.DISABLED || isLoading}
                            >
                                Subscribe now
                            </Button>
                        )}
                        {changePlanAction && (
                            <Button
                                type="secondary"
                                onClick={handleChangePlanClick}
                                disabled={changePlanAction.status === EActionStatus.DISABLED || isLoading}
                            >
                                Change plan
                            </Button>
                        )}
                        {getFeatureToggle(ToggleNames.FEATURE_SSP_ACTIONS) && editPaymentDetailsAction && (
                            <Button
                                type="secondary"
                                onClick={handleEditPaymentDetailsClick}
                                disabled={editPaymentDetailsAction.status === EActionStatus.DISABLED || isLoading}
                            >
                                Edit payment details
                            </Button>
                        )}
                        {actionNotification && <small role="note">{actionNotification.message}</small>}
                    </ActionsWrapper>
                </ActionsElementContainer>
            )}
        </>
    );
};

export default Actions;
